import { render, staticRenderFns } from "./UserRecordCreator.vue?vue&type=template&id=266b006e&"
import script from "./UserRecordCreator.vue?vue&type=script&lang=js&"
export * from "./UserRecordCreator.vue?vue&type=script&lang=js&"
import style0 from "./UserRecordCreator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports